export default __webpack_public_path__ + "static/media/IMG_20210412_094629_947.33d2a82b.jpg";